import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { EjercicioSelect } from "../../helpers/EjercicioSelected";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../ReporteCobranza/Actions/GetContainer";
import { EjercicioByRange } from "../ReporteCobranza/Helper/EjercicioByRange";
import { PeriodoSelect } from "../ReporteCobranza/Helper/PeriodoSelect";
import { LineaCreditoSelect } from "../ReporteCobranza/Helper/LineaCreditoSelect";

const FiltroPedidosFacturados = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
  sucursales
}) => {
  const [openModal, setOpenModal] = useState(false);
  const storedState = JSON.parse(localStorage.getItem('state')) || {};
  const fecha = new Date();

  const anoActual = fecha.getFullYear().toString();
  const mesActual = (fecha.getMonth() + 1).toString();
  const [state, setState] = useState({
    ejercicio: storedState.ejercicio || anoActual,
    periodo: storedState.periodo || mesActual,
    adr: [],
    sucursal: [],
    departamento: [],
    linea: "C"
  });

  const guardarState = (state) => {
    // const { ejercicio, periodo } = state; 
    // const newstate = { ejercicio, periodo }; 
    // localStorage.setItem('state', JSON.stringify(state)); 
  };

  const {
    data,
    adr,
    sucursal,
    departamento,
  } = state;
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  useEffect(() => {
    // onClose();
    if (cargarfiltros)
      GetASD()
        .then((res) => {
          setState({
            ...state,
            data: res,
          });
          let sucursalesSeleccionadas = boxState?.pv?.sucursal?.length > 0
            ? boxState.pv.sucursal
            : sucursales.map(s => ({ idsucursal: s.idsucursal, sucursal: s.sucursal || s.nombreSucursal || "" }));
          onBoxChange("pv", {
            adr: GroupByProps(res, ["idadr", "adr"]),
            sucursal: sucursalesSeleccionadas,
            departamento: [],
          });
        })
        .catch((err) => console.log(err));
  }, []);

  const idsSucursalPermitidas = [...new Set(sucursales?.map(s => String(s.idsucursal)))];

  const sucursalFiltrada = sucursal.filter(item => idsSucursalPermitidas.includes(item.idsucursal));

  const adrFiltrado = adr?.filter(itemAdr =>
    data.some(d => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
  );

  useEffect(() => {
    if (!data || data.length === 0) return;

    var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    var newdepartamento = GroupByPropCheck(data, ["iddepartamento", "departamento"], false);

    // Aplicar el estado checked guardado en localStorage si existe
    const savedState = JSON.parse(localStorage.getItem("state")) || {};

    if (savedState.adr && savedState.adr.length > 0) {
      newadr = newadr.map((item) => ({
        ...item,
        checked: savedState.adr.some((a) => a.idadr === item.idadr && a.checked),
      }));
    }

    if (savedState.sucursal && savedState.sucursal.length > 0) {
      newsucursal = newsucursal.map((item) => ({
        ...item,
        checked: savedState.sucursal.some((s) => s.idsucursal === item.idsucursal && s.checked),
      }));
    }

    setState({
      ...state,
      adr: newadr,
      sucursal: newsucursal,
      departamento: newdepartamento,
    });
  }, [data]);

  const onCargar = () => {
    if (
      state.ejercicio === undefined ||
      state.ejercicio === null ||
      state.ejercicio === ""
    ) {
      Swal.fire(
        "PEDIDOS FACTURADOS",
        "Favor de seleccionar el ejercicio",
        "warning"
      );
      return;
    }
    if (
      state.periodo === undefined ||
      state.periodo === null ||
      state.periodo === ""
    ) {
      Swal.fire(
        "PEDIDOS FACTURADOS",
        "Favor de seleccionar el periodo",
        "warning"
      );
      return;
    }
    guardarState(state)
    onExecute(state.ejercicio, state.periodo, state.linea, state.sucursal, state.adr)
      .then((result) => {
        onOpenModal();
      })
      .catch((error) => {
        Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
      });
  };

  const labelclick = ({ target }) => {
    target.parentNode.firstChild.click();
  };

  const selectedClick = ({ target }, index) => {
    switch (target.name) {
      case "chk-adr":
        var newarray = adr;
        newarray[index].checked = target.checked;

        var newarrarsucursal = [];
        var newarraydepartamento = [];
        var adrActive = [];
        newarray.forEach((item) => {
          if (item.checked) {
            adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
            newarrarsucursal = newarrarsucursal.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "idsucursal",
                "sucursal",
              ])
            );
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: adrActive,
          sucursal: [],
          departamento: [],
        });
        setState({
          ...state,
          adr: newarray,
          sucursal:
            newarrarsucursal.length == 0
              ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
              : GroupByPropCheck(
                newarrarsucursal,
                ["idsucursal", "sucursal"],
                false
              ),
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      case "chk-sucursal":
        var newarray = sucursal;
        newarray[index].checked = target.checked;

        var newarraydepartamento = [];
        var sucursalactiva = [];
        newarray.forEach((item) => {
          if (item.checked) {
            sucursalactiva = [
              ...sucursalactiva,
              { idsucursal: item.idsucursal, sucursal: item.sucursal },
            ];
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: sucursalactiva,
          departamento: [],
        });
        setState({
          ...state,
          sucursal: newarray,
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      default:
        var newarray = departamento;
        var departamentoactivo = [];
        newarray[index].checked = target.checked;

        newarray.forEach((item) => {
          if (item.checked) {
            departamentoactivo = [
              ...departamentoactivo,
              {
                iddepartamento: item.iddepartamento,
                departamento: item.departamento,
              },
            ];
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: boxState.pv.sucursal,
          departamento: departamentoactivo,
        });
        setState({
          ...state,
          departamento: newarray,
        });
        break;
    }
  };

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  console.log()

  return (
    <div className="filtros-pedidos-facturados">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={"modal-filtro-resumen-cartera-mensual"}
        >
          <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
            X
          </div>
          <div className="modal-filtro-resumen-cartera-mensual-container">
            <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
              <div className="filtro-tiempo-tipo">
                {/* <EjercicioSelect
                  start_year={2024}
                  value={state.ejercicio}
                  onChange={(ejercicio) => setState({ ...state, ejercicio })}
                /> */}
                <div className="filtro-group">
                  <label>Ejercicio</label>
                  <EjercicioByRange
                    name="ejercicio"
                    value={state.ejercicio}
                    onChange={onChange}
                  />
                  <label>Periodo</label>
                  <PeriodoSelect
                    name="periodo"
                    value={state.periodo}
                    onChange={onChange}
                  />
                  {/* <label>Línea de Crédito</label>
                  <LineaCreditoSelect
                    name="linea"
                    value={state.linea}
                    onChange={onChange}
                  /> */}
                </div>
                <div
                  className="mdlFiltros-modal-acciones-guardar"
                  onClick={onCargar}
                >
                  Cargar
                </div>
              </div>
              <div className="filtro-adr">
                <div className="title title-adr">REGION</div>
                {adrFiltrado.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-adr"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idadr}
                    />
                    <label>{item.adr}</label>
                  </div>
                ))}
              </div>
              <div className="filtro-sucursal">
                <div className="title-sucursal">SUCURSAL</div>
                {sucursalFiltrada.map((item, index) => (
                  <div key={`${item}-${index}`} className="chk-groups">
                    <input
                      type="checkbox"
                      name="chk-sucursal"
                      className="my-checkbox"
                      onChange={(e) => selectedClick(e, index)}
                      checked={item.checked}
                      value={item.idsucursal}
                    />
                    <label onClick={labelclick}>{item.sucursal}</label>
                  </div>
                ))}
              </div>
            </div>
            <div className="mdlFiltros-modal-acciones">
              {/* <div
                className="mdlFiltros-modal-acciones-cancelar"
                onClick={onOpenModal}
              >
                Cancelar
              </div> */}

            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};

export default FiltroPedidosFacturados;
